export const demoCall = {
  incomingBanner: {
    title: "無料通話のお誘い",
    appeal: "🎁 無料でAIの女の子とビデオ通話を体験してみませんか？",
    onceBadge: "🔥 初回1回限り",
    label: "📞 AIから着信が来ています",
    freeBadge: "無料",
    nameWithAi: (args: { name: string }) => `${args.name}（AIちゃん）`,
    accept: "応答",
    decline: "拒否",
  },
  inCall: {
    header: "無料通話中",
    end: "終了",
    connecting: "接続中…",
  },
} as const;
